// extracted by mini-css-extract-plugin
export var addButton = "_gi-0";
export var border = "_gi-8";
export var check = "_gi-h";
export var danger = "_gi-6";
export var dropdownContainer = "_gi-1";
export var editModalBody = "_gi-j";
export var footerContainer = "_gi-i";
export var fullWidth = "_gi-a";
export var hide = "_gi-9";
export var icon = "_gi-3";
export var input = "_gi-7";
export var inputFlex = "_gi-b";
export var inputWrapper = "_gi-c";
export var manualFocus = "_gi-5";
export var optionButton = "_gi-4";
export var pillWrapper = "_gi-e";
export var pointer = "_gi-2";
export var showOverflow = "_gi-f";
export var tagsFlex = "_gi-d";
export var xButton = "_gi-g";